import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { SettingsProvider } from './context/SettingsContext';
import { MetalRatesProvider } from './context/MetalRatesContext';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AuthPage from './pages/AuthPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import CustomerDashboard from './pages/CustomerDashboard';
import TrackOrderPage from './pages/TrackOrderPage';
import SupportPage from './pages/SupportPage';
import FeedbackPage from './pages/FeedbackPage';
import AdminDashboard from './pages/AdminDashboard';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import SilverRatesPage from './pages/SilverRatesPage';
import PolicyPage from './pages/PolicyPage';
import MobileRatePushPage from './pages/MobileRatePushPage';
import WebhookStatusPage from './pages/WebhookStatusPage';
import { initGA, trackPageView } from './utils/analytics';
import './App.css';

// Initialize Google Analytics on app load
initGA();

// Component to track page views
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <SettingsProvider>
          <BrowserRouter>
            <AuthProvider>
              <MetalRatesProvider>
              <PageTracker />
              <CartProvider>
                <ScrollToTop />
                <div className="App">
                  <Routes>
                    <Route path="/push-rates" element={null} />
                    <Route path="/webhook-status" element={null} />
                    <Route path="*" element={<Navbar />} />
                  </Routes>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                  <Route path="/products" element={<ProductsPage />} />
                  <Route path="/product/:id" element={<ProductDetailPage />} />
                  <Route path="/login" element={<AuthPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/dashboard" element={<CustomerDashboard />} />
                  <Route path="/track-order" element={<TrackOrderPage />} />
                  <Route path="/support" element={<SupportPage />} />
                  <Route path="/feedback" element={<FeedbackPage />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/analytics" element={<AnalyticsDashboard />} />
                  <Route path="/silver-rates" element={<SilverRatesPage />} />
                  <Route path="/policies" element={<PolicyPage />} />
                  <Route path="/policies/:type" element={<PolicyPage />} />
                  <Route path="/push-rates" element={<MobileRatePushPage />} />
                  <Route path="/webhook-status" element={<WebhookStatusPage />} />
                </Routes>
                <Routes>
                  <Route path="/push-rates" element={null} />
                  <Route path="/webhook-status" element={null} />
                  <Route path="*" element={<Footer />} />
                </Routes>
                <Toaster 
                  position="top-right" 
                  richColors 
                  duration={2000}
                  offset="80px"
                  toastOptions={{
                    style: {
                      marginTop: '60px'
                    }
                  }}
                />
              </div>
            </CartProvider>
          </MetalRatesProvider>
          </AuthProvider>
        </BrowserRouter>
      </SettingsProvider>
    </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;